import { Column } from "@/components";
import { PlayyardSky } from "@/types";

const BRAZIERS = [
  { left: 31, top: 50, size: 2.2 },
  { left: 56, top: 50, size: 2.2 },
  { left: 2, top: 73, size: 2.8 },
  { left: 97, top: 73, size: 2.8 },
];

export const PlayyardNightLights = ({ sky }: { sky: PlayyardSky }) => {
  /* Helpers */
  const glowOpacity = 0.12 + sky.nightAmount * 0.65;

  /* Render */
  const render = () => (
    <Column className="pointer-events-none absolute inset-0 z-[42]">
      {BRAZIERS.map(({ left, top, size }) => (
        <Column
          key={left}
          className="absolute -translate-x-1/2 -translate-y-full"
          style={{
            left: `${left}%`,
            top: `${top}%`,
            width: `${size}cqw`,
            height: `${size * 1.9}cqw`,
          }}
        >
          <Column
            className="absolute -inset-x-full -top-1/2 bottom-0 rounded-full bg-amber-300 blur-xl transition-opacity duration-1000"
            style={{ opacity: glowOpacity }}
          />
          <svg className="relative h-full w-full" viewBox="0 0 40 76">
            <path d="M16 42H24L27 73H13Z" fill="#3b4c5b" />
            <path d="M10 74H30M16 61H24" stroke="#91a5b3" strokeWidth="2" />
            <path
              d="M5 27H35L29 46H11Z"
              fill="#293b4d"
              stroke="#7c8f9c"
              strokeWidth="2"
            />
            <path
              d="M12 31C1 18 19 16 17 1c13 11 6 16 13 24 6 8-1 14-10 14Z"
              fill="#ef9948"
            />
            <path
              d="M18 34C10 25 21 22 22 13c7 10 1 12 4 18 2 5-3 8-8 3Z"
              fill="#ffe5a8"
            />
            <path
              d="M11 27 15 44M20 27V45M29 27 25 44"
              stroke="#293b4d"
              strokeWidth="2"
            />
          </svg>
        </Column>
      ))}
    </Column>
  );

  return render();
};
